import React, { useReducer, useEffect, useContext, useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { getComponentName } from '../../services/utils'
import { GlobalContext, AuthContext } from '../../services/context'
import { sendAmplitudeData } from '../../services/amplitudeHelper'
import { signOut } from '../../services/apiHelper'

const contextDefault = JSON.parse(window.localStorage.getItem('context')) || {
  detailView: {
    title: '',
    previous: 'Back'
  },
  userInfo: {
    first: '',
    last: '',
    phone: '',
    user_id: null,
    cognito_id: null
  },
  userPermission: {
    hasChanged: false
  }
}
/* eslint-disable */

export const ContextWrapper = props => {
  const history = useHistory()
  const contextReducer = useCallback(
    (state, action) => {
      switch (action.type) {
        case 'TRACK_EVENT': {
          if (action.payload.eventType) {
            if (action.payload.eventProperties) {
              sendAmplitudeData(
                action.payload.eventType,
                action.payload.eventProperties
              )
            } else {
              sendAmplitudeData(action.payload.eventType)
            }
          }
          return { ...state }
        }
        case 'TRACK_EVENT_WITH_PATH': {
          if (action.payload.eventType) {
            if (action.payload.eventProperties) {
              sendAmplitudeData(
                `${getComponentName(action.payload.pathName)}_${
                action.payload.eventType
                }`,
                action.payload.eventProperties
              )
            } else {
              sendAmplitudeData(
                `${getComponentName(action.payload.pathName)}_${
                action.payload.eventType
                }`
              )
            }
          }
          return { ...state }
        }
        case 'TRACK_PAGE_VIEW': {
          sendAmplitudeData('navigation_changed', { path: action.payload })
          return { ...state }
        }
        case 'GO_BACK': {
          history.goBack()
          return { ...state, detailView: state.lastDetailView, lastDetailView: state.detailView }
        }
        case 'SET_DETAIL_VIEW': {
          return { ...state, detailView: action.payload, lastDetailView: state.detailView }
        }
        case 'UPDATE_DETAIL_VIEW_SAVE_LAST_VIEW': {
          return { ...state, detailView: action.payload }
        }
        case 'UPDATE_USER_PROFILE': {
          return { ...state, userInfo: action.payload ? action.payload : null }
        }
        case 'LOGIN_USER': {
          return { ...state, loggedIn: true }
        }
        case 'LOG_OUT': {
          signOut()
          return { ...state, loggedIn: false, accessToken: null }
        }
        case 'UPDATE_CONTRACT_DETAILS':
          return { ...state, contract_id: action.payload, detailView: { previous: 'Contracts', title: action.payload } }
        case 'SET_CONTRACT_VIEW': {
          return { ...state, detailView: action.payload }
        }
        case 'GO_TO_LOGIN':
          history.push('/login')
          return { ...state }
        case 'GO_TO_DASHBOARD':
          history.push('/contracts')
          return { ...state }
        case 'GO_TO_VIEW_PRODUCTION_PLAN': {
          const { detailView, productionPlanDetails, company_id } = action.payload
          history.push(`/company/${company_id}/production-plan/view/${productionPlanDetails.production_plan_id}`)
          return { ...state, productionPlanDetails, detailView }
        }
        case 'GO_TO_CREATE_PRODUCTION_PLAN': {
          const { detailView, company_id } = action.payload
          history.push(`/company/${company_id}/production-plan/create?company_id=${company_id}`)
          return { ...state, detailView }
        }
        case 'GO_TO_EDIT_PRODUCTION_PLAN': {
          const { production_plan_id, company_id } = action.payload
          history.push(`/company/${company_id}/production-plan/edit/${production_plan_id}`)
          return { ...state }
        }
        case 'GO_TO_MASTER_AGREEMENT': {
          const { detailView, contract_template_id, company_id } = action.payload
          history.push(`/company/${company_id}/master-agreement/${contract_template_id}`)
          return { ...state, detailView, lastDetailView: state.detailView }
        }
        case 'GO_TO_USER_DETAIL': {
          const { id, company_id } = action.payload
          history.push(`/company/${company_id}/user/${id}`)
          return { ...state, detailView: action.payload, lastDetailView: state.detailView }
        }
        case 'GO_TO_UPLOAD_SCALE_TICKET': {
          const { detailView, company_id, prod_plan_id } = action.payload
          history.push(`/company/${company_id}/upload-scale-ticket/${prod_plan_id}`)
          return { ...state, detailView }
        }
        case 'GO_TO_COMPANY_DETAIL_VIEW': {
          const { company_id, detailView } = action.payload
          history.push(`/company/${company_id}`)
          return { ...state, detailView, lastDetailView: state.detailView }
        }
        case 'GO_COMPANY_VIEW': {
          history.push(`/company/${action.payload.id}`)
          return { ...state, detailView: action.payload, lastDetailView: state.detailView }
        }
        case 'GO_TO_STEWARDSHIP_DETAIL': {
          const { company_id, stewardship_activity_id } = action.payload
          history.push(`/company/${company_id}/stewardship/${stewardship_activity_id}`)
          return { ...state, detailView: action.payload }
        }
        // case 'GO_TO_CREATE_CONTRACT': {
        //   const { detailView, queryParams } = action.payload
        //   history.push(`/contracts/new-contract${queryParams ? `?${queryParams}` : ''}`)
        //   return { ...state, detailView }
        // }
        case 'GO_TO_CONTRACT': {
          const { detailView, contract_id, company_id } = action.payload
          history.push(`/company/${company_id}/contracts/${contract_id}`)
          return { ...state, detailView }
        }
        case 'GO_TO_SIGN_CONTRACT': {
          const { company_id } = action.payload
          history.push(`/company/${company_id}/contracts/sign-pdf/${action.payload.contract_id}`)
          return { ...state }
        }
        case 'GO_TO_VOID_CONTRACT': {
          const { company_id, contract_id } = action.payload
          history.push(`/company/${company_id}/contracts/amend-contract/${contract_id}`)
          return { ...state }
        }
        case 'GO_TO_CONTRACT_COMPLETE':
          history.push('/contracts/complete')
          return { ...state }
        case 'GO_TO_CONTRACT_PDF_VIEW': {
          const { detailView, contractDetails, company_id } = action.payload
          const { contract_id, contract_doc_link } = contractDetails
          const pushable = `/company/${company_id}/contracts/view-pdf/${contract_id}?contract_doc_link=${encodeURIComponent(contract_doc_link)}`
          history.push(pushable)
          return { ...state, detailView, contractDetails }
        }
        case 'SENT_FOR_SIGNING': {
          const { contract_id, detailView, company_id } = action.payload
          const newState = { ...state, detailView }
          delete newState.contractDetails
          history.push(`/company/${company_id}/contracts/${contract_id}`)
          return newState
        }
        case 'GO_TO_SEARCH': {
          history.push('/search')
          return { ...state }
        }
        case 'GO_TO_404': {
          history.push('/404')
          return { ...state }
        }
        case 'PERMISSIONS_CHANGED': {
          const newValue = state.userPermission && state.userPermission.hasChanged !== undefined ? !state.userPermission.hasChanged : false
          const newState = { ...state, userPermission: { hasChanged: newValue  } }
          return newState
        }
        default:
          throw new Error('contextWrapper missing case')
      }
    }, [history]
  )

  const [state, dispatch] = useReducer(contextReducer, contextDefault)

  const trackEvent = useCallback((eventType, eventProperties) => {
    sendAmplitudeData(eventType, eventProperties)
  }, [])

  const passable = { state, dispatch, trackEvent }

  const { auth } = useContext(AuthContext)

  useEffect(() => {
    if (auth.loggedIn === 'SUCCESS') {
      window.localStorage.setItem('context', JSON.stringify(state))
    }
  }, [state, auth.loggedIn])

  return (
    <GlobalContext.Provider value={passable}>
      {props.children}
    </GlobalContext.Provider>
  )
}

export default ContextWrapper

ContextWrapper.propTypes = {}
